import { Flex, Text } from '@optiaxiom/react';
import { IconCircleCheck, IconCircleXmark } from '@optimizely/axiom-icons';

const formatEvaluationScore = (score: number | null | undefined) => {
  return score != null ? `${score}%` : '—';
};

const getQualityScoreIcon = (score: number | null | undefined, baseline: number | undefined) => {
  if (score == null || baseline == null) {
    return null;
  }

  if (score >= baseline) {
    return <IconCircleCheck size="16" color="green" />;
  }

  return <IconCircleXmark size="16" color="red" />;
};

export function EvaluationScoreCell({
  evaluationScore,
  baselineEvaluationScore,
}: {
  evaluationScore: number | null;
  baselineEvaluationScore?: number;
}) {
  return (
    <Flex flexDirection="row" alignItems="center" gap="8">
      {getQualityScoreIcon(evaluationScore, baselineEvaluationScore)}
      <Text fontSize="md">{formatEvaluationScore(evaluationScore)}</Text>
    </Flex>
  );
}
